import React from 'react';
import SelectyBox from './selectybox';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { VoyageDataDTO } from '../voyageDTO';
import { api, date } from '../utils';
import differenceInDays from 'date-fns/difference_in_days';
import addDays from 'date-fns/add_days';
import format from 'date-fns/format';
import isDate from 'date-fns/is_date';

export default class Filter extends React.Component {
  constructor(props) {
    super(props);

    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.setFromDate = this.setFromDate.bind(this);
    this.setToDate = this.setToDate.bind(this);
    this.setPort = this.setPort.bind(this);
    this.setVessel = this.setVessel.bind(this);
    this.setVoyage = this.setVoyage.bind(this);
    this.setRoute = this.setRoute.bind(this);
    this.renderFromDate = this.renderFromDate.bind(this);
    this.setToDate = this.setToDate.bind(this);
    this.dateFormat = 'DD/MM/YYYY';

    this.state = {
      ports: props.ports ? props.ports : [],
      vessels: props.vessels ? props.vessels : [],
      voyages: props.voyages ? props.voyages : [],
      routes: props.routes ? props.routes : [],
      fromDate: props.fromDate,
      toDate: props.toDate,
      portCode: props.portCode,
      vesselRef: props.vesselRef,
      voyageRef: props.voyageRef,
      voyageData: props.voyageData,
      routeRef: props.routeData
    };

    this.datePickerInputClassNames = {
      container: 'datepickerinput',
      overlayWrapper: 'datepickerwrapper',
      overlay: 'datepickerwrapperoverlay'
    };

    this.datePickerClassNames = {
      container: 'datepicker',

      wrapper: 'datepicker__wrapper',
      interactionDisabled: 'interaction-disabled',
      navBar: 'datepicker__nav',
      navButtonPrev: 'datepicker__nav__prev',
      navButtonNext: 'datepicker__nav__next',
      navButtonInteractionDisabled: 'nav-disabled',
      month: 'datepicker__month',
      caption: 'datepicker__caption',
      weekdays: 'datepicker__weekdays',
      weekdaysRow: 'datepicker__weekdays__row',
      weekday: 'datepicker__weekday',
      body: 'datepicker__calendar',
      week: 'datepicker__week',
      day: 'datepicker__day',
      footer: 'bottom',
      todayButton: 'today-button',
      today: 'datepicker__today',
      selected: 'datepicker__selected',
      disabled: 'datepicker__disabled',
      outside: 'datepicker__outside'
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  handleConfirm() {
    const comp = this;
    const state = comp.state;
    const fromDate = state.fromDate ? format(state.fromDate, this.dateFormat) : state.fromDate;
    const toDate = state.toDate ? format(state.toDate, this.dateFormat) : state.toDate;

    if (isDate(fromDate) && isDate(toDate)) {
      api.getVoyages(fromDate, toDate, '', '', '').then(data => {
        comp.props.hoistState({ voyageData: new VoyageDataDTO(data.rangedVoyages) });
      });
    } else {
      console.log('to and from date must be set');
    }
  }

  handleClear() {
    const stateReset = {
      fromDate: undefined,
      toDate: undefined,
      portCode: '',
      vesselRef: '',
      voyageRef: '',
      routeRef: ''
    };
    this.setState(stateReset);
    this.props.hoistState({
      portCode: '',
      vesselRef: '',
      voyageRef: '',
      routeRef: '',
      lastFilter: undefined,
      clear: true,
      rangedData: false
    });
  }

  setFromDate(date) {
    let toDate = this.state.toDate;
    if (toDate) {
      const dayDiff = differenceInDays(toDate, date);
      if (dayDiff < 14) {
        toDate = addDays(toDate, 15 - dayDiff);
      }
    }
    this.setState({ fromDate: date, toDate: toDate });
    this.fetchRangedData(date, toDate);
  }

  fetchRangedData(fromDate, toDate) {
    if (fromDate && toDate) {
      api
        .getVoyages(
          format(fromDate, this.dateFormat),
          format(toDate, this.dateFormat),
          '',
          '',
          '',
          ''
        )
        .then(data => {
          const voyageDataDTO = new VoyageDataDTO(data.rangedVoyages);
          this.props.hoistState({
            rangedData: isDate(fromDate) && isDate(toDate),
            voyageData: voyageDataDTO,
            vessels: voyageDataDTO.getVessels(),
            ports: voyageDataDTO.getPorts(),
            voyages: voyageDataDTO.getVoyages()
          });
        });
    }
  }

  setToDate(date) {
    this.setState({ toDate: date });
    this.fetchRangedData(this.state.fromDate, date);
  }

  setPort(portCode) {
    const lastFilter = portCode ? 'portCode' : undefined;
    this.props.hoistState({ portCode: portCode });
    this.setState({ portCode: portCode, lastFilter: lastFilter });
  }

  setVessel(vesselRef) {
    const lastFilter = vesselRef ? 'vesselRef' : undefined;
    const voyageData = this.state.voyageData;
    let stateUpdate = {
      vesselRef: vesselRef,
      lastFilter: lastFilter
    };

    if (voyageData) {
      let voyages = voyageData.getVoyages();
      let ports = voyageData.getPorts();

      if (vesselRef) {
        voyages = voyageData.getVoyagesByVesselReference(vesselRef);
        ports = voyageData.getPortsByVesselReference(vesselRef);
      }

      stateUpdate = {
        voyageData: voyageData,
        vesselRef: vesselRef,
        ports: ports,
        voyages: voyages,
        lastFilter: lastFilter
      };
    }

    this.setState(stateUpdate);
    this.props.hoistState(stateUpdate);
  }

  setVoyage(voyageRef) {
    const lastFilter = voyageRef ? 'voyageRef' : undefined;
    this.setState({ voyageRef: voyageRef });
    this.props.hoistState({ voyageRef: voyageRef, lastFilter: lastFilter });
  }

  setRoute(routeRef) {
    const lastFilter = routeRef ? 'routeRef' : undefined;
    this.setState({ routeRef: routeRef });
    this.props.hoistState({ routeRef: routeRef, lastFilter: lastFilter });
  }

  renderFromDate() {
    let maxDate = new Date();
    let minDate = new Date();
    const disabledAfterDate = this.state.toDate;

    maxDate.setDate(maxDate.getDate() + 365);
    minDate.setDate(minDate.getDate() - 365);

    let fromDayPickerProps = {
      classNames: this.datePickerClassNames,
      selectedDays: this.state.fromDate,
      initialMonth: new Date(),
      fromMonth: minDate,
      disabledDays: [{ after: disabledAfterDate, before: minDate }, disabledAfterDate]
    };

    return (
      <div className="filters__date filters__date--datefrom">
        <label>{this.props.lang === 'is' ? "Dags frá" : "Date from"}</label>
        <DayPickerInput
          placeholder={this.props.lang === 'is' ? "Dags frá" : "Date from"}
          dayPickerProps={fromDayPickerProps}
          formatDate={date.formatDate}
          value={this.state.fromDate}
          classNames={this.datePickerInputClassNames}
          onDayChange={this.setFromDate}
        />
      </div>
    );
  }

  renderToDate() {
    const fromDate = this.state.fromDate;
    let maxDate = fromDate ? new Date(fromDate.getTime()) : new Date();
    let minDate = fromDate ? new Date(fromDate.getTime()) : new Date();
    let disabledDays = fromDate ? new Date(fromDate.getTime()) : new Date();

    maxDate.setDate(maxDate.getDate() + 365);
    minDate.setDate(minDate.getDate() - 365);
    disabledDays.setDate(disabledDays.getDate() + 14);

    let toDayPickerProps = {
      classNames: this.datePickerClassNames,
      selectedDays: this.state.toDate,
      initialMonth: disabledDays,
      fromMonth: disabledDays,
      disabledDays: [{ before: disabledDays }, { before: minDate, after: maxDate }, disabledDays]
    };

    return (
      <div className="filters__date filters__date--dateto">
        <label>{this.props.lang === 'is' ? "Dags til" : "Date to"}</label>
        <DayPickerInput
          placeholder={this.props.lang === 'is' ? "Dags til" : "Date to"}
          dayPickerProps={toDayPickerProps}
          formatDate={date.formatDate}
          value={this.state.toDate}
          classNames={this.datePickerInputClassNames}
          onDayChange={this.setToDate}
        />
      </div>
    );
  }

  compareSelectOptions(a, b) {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }

    return 0;
  }

  render() {
    const comp = this;
    const state = comp.state;

    const routes = state.routes
      .map(route => {
        return { label: route, id: route, value: route };
      })
      .sort(this.compareSelectOptions);

    const voyages = state.voyages
      .map(voyage => {
        return { label: voyage.reference, id: voyage.reference, value: voyage.reference };
      })
      .sort(this.compareSelectOptions);

    const ports = state.ports
      .map(port => {
        return { label: port.name, id: port.portCode, value: port.portCode };
      })
      .sort(this.compareSelectOptions);

    const vessels = state.vessels
      .map(vessel => {
        return { label: vessel.name, id: vessel.reference, value: vessel.reference };
      })
      .sort(this.compareSelectOptions);

    return (
      <div className="filters">
        {this.renderFromDate()}
        {this.renderToDate()}

        <div className="filters__selecty">
          <SelectyBox
            options={routes}
            labelText={this.props.lang === 'is' ? "Sía eftir leið" : "Filter by route"}
            onChange={this.setRoute}
            value={this.state.routeRef}
            defaultValue={this.props.lang === 'is' ? "Sía eftir leið" : "Filter by route"}
          />
        </div>

        <div className="filters__selecty">
          <SelectyBox
            options={vessels}
            labelText={this.props.lang === 'is' ? "Sía eftir skipi" : "Filter by vessel"}
            onChange={this.setVessel}
            value={this.state.vesselRef}
            defaultValue={this.props.lang === 'is' ? "Sía eftir skipi" : "Filter by vessel"}
          />
        </div>

        <div className="filters__selecty">
          <SelectyBox
            options={ports}
            labelText={this.props.lang === 'is' ? "Sía eftir höfn" : "Filter by port"}
            onChange={this.setPort}
            value={this.state.portCode}
            defaultValue={this.props.lang === 'is' ? "Sía eftir höfn" : "Filter by port"}
          />
        </div>

        <div className="filters__selecty">
          <SelectyBox
            options={voyages}
            labelText={this.props.lang === 'is' ? "Sía eftir ferð" : "Filter by voyage"}
            onChange={this.setVoyage}
            value={this.state.voyageRef}
            defaultValue={this.props.lang === 'is' ? "Sía eftir ferð" : "Filter by voyage"}
          />
        </div>

        {/* <button type="button" onClick={this.handleConfirm} className="filters__button filters__button__confirm">Confirm</button> */}
        <button
          type="button"
          onClick={this.handleClear}
          className="filters__button filters__button__clear"
        >
          {this.props.lang === 'is' ? "Hreinsa" : "Clear"}
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/filter.js